import { render, staticRenderFns } from "./LsSelectOrg.vue?vue&type=template&id=666b3ab1&scoped=true"
import script from "./LsSelectOrg.vue?vue&type=script&lang=js"
export * from "./LsSelectOrg.vue?vue&type=script&lang=js"
import style0 from "./LsSelectOrg.vue?vue&type=style&index=0&id=666b3ab1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666b3ab1",
  null
  
)

export default component.exports